import { ko } from 'src/i18n/ko/ko';
import { en } from 'src/i18n/en/en';

export default {
  ko: ko,
  en: en,
};
